import { types } from "mobx-state-tree"

export const OverlayService = types
    .model({
        id: types.optional(types.number, -1),
        name: types.optional(types.string,""),
        url: types.optional(types.string, ""),
        key: types.optional(types.string, ""),
        active: types.optional(types.number, 1),
        opacity: types.optional(types.number, 1),
        queryable: types.optional(types.number, 1),
        type: types.optional(types.number, 0),
        zIndex: types.optional(types.number, 0),
        legends: types.maybeNull(types.string, "")
    }).actions(self => ({

    }))
